// Shared Mapbox helpers used across Find, ProListing, and Pellet pages.
// Reads the public token from REACT_APP_MAPBOX_TOKEN.
//
// We use the CSP build of mapbox-gl (dist/mapbox-gl-csp) + an explicit
// workerUrl pointing at a static worker file in /public. This avoids a known
// mapbox-gl 3.x bug where CRA's production minifier mangles the inline worker
// blob and crashes every tile load with "ReferenceError: r is not defined".
// The static worker file is a verbatim copy of
// node_modules/mapbox-gl/dist/mapbox-gl-csp-worker.js kept in frontend/public.
import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp";
import "mapbox-gl/dist/mapbox-gl.css";

const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || "";
if (TOKEN) {
  mapboxgl.accessToken = TOKEN;
}
mapboxgl.workerUrl = `${process.env.PUBLIC_URL || ""}/mapbox-gl-csp-worker.js`;

export { mapboxgl, TOKEN as MAPBOX_TOKEN };
export const MAPBOX_STYLE = "mapbox://styles/mapbox/dark-v11";
export const BRAND_BLUE = "#00D4FF";
export const BRAND_ORANGE = "#FF5722";
